<template>
  <div data-test="page-header-fixed" class="sticky top-0 z-30 last:mb-0">
    <div class="bg-p-blue-50 pb-5">
      <slot></slot>
    </div>
  </div>
</template>
